import React from 'react';
const stats = [{
  value: '+1.200',
  label: 'mamás ya lo tienen'
}, {
  value: '6+6',
  label: 'Tomos + Bonos'
}, {
  value: '4.9/5',
  label: 'calificación ⭐'
}, {
  value: '🇦🇷',
  label: 'Todo el país'
}];
const testimonials = [{
  initials: 'VR',
  quote: '"Mi hijo tenía el celu pegado en la mano todo el día. Con el Megapack lo cambié por las fichas y ahora me pide él solo sentarse a colorear. No lo puedo creer."',
  author: '— Valentina R., Buenos Aires | Mamá de Tomás, 4 años'
}, {
  initials: 'CM',
  quote: '"Estaba desesperada buscando actividades en Pinterest que nunca funcionaban. Con esto tengo todo listo para imprimir y mi hijo aprende jugando. Vale cada peso."',
  author: '— Carolina M., Córdoba | Mamá de Juanita, 5 años'
}, {
  initials: 'LS',
  quote: '"Lo descargué un domingo y ese mismo día lo imprimí. Mi hija pasó 2 horas sentada sin pedirme el teléfono. Eso para mí no tiene precio."',
  author: '— Luciana S., Rosario | Mamá de Sofía, 3 años'
}];
export function SocialProof() {
  return <section className="w-full px-4 py-8 text-gray-900 text-base leading-6" style={{
    backgroundColor: 'rgb(255, 247, 237)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-297">
      <div className="mx-auto max-w-4xl" data-id="element-298">

        {/* TÍTULO DE SECCIÓN */}
        <div className="text-center mb-6" data-id="element-299">
          <p className="text-xs sm:text-sm font-black text-orange-500 tracking-widest uppercase mb-1" data-id="element-300">
            🔥 Lo que dicen las mamás
          </p>
          <h2 className="text-xl sm:text-2xl font-black text-gray-900 m-0" data-id="element-301">
            Más de 1.200 familias ya recuperaron
            <span className="text-orange-500" data-id="element-302"> sus tardes</span>
          </h2>
        </div>

        {/* STATS */}
        <div className="mb-8 grid grid-cols-2 md:grid-cols-4 gap-3 text-center" data-id="element-303">
          {stats.map(stat => <div key={stat.label} className="bg-white rounded-xl py-3 px-2 shadow-sm border border-orange-200" data-id="element-304">
              <div className="text-2xl sm:text-4xl leading-[32px] sm:leading-[40px] font-black text-gray-900" data-id="element-305">
                {stat.value}
              </div>
              <div className="mt-1 text-[10px] sm:text-xs font-semibold text-orange-500" data-id="element-306">
                {stat.label}
              </div>
            </div>)}
        </div>

        {/* TESTIMONIALS */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3" data-id="element-307">
          {testimonials.map(t => <div key={t.initials} className="flex items-start gap-2 bg-white border border-orange-200 rounded-xl p-4 shadow-sm" data-id="element-308">
              <div className="flex h-9 w-9 shrink-0 items-center justify-center bg-orange-100 text-xs font-black text-orange-500 rounded-full" data-id="element-309">
                {t.initials}
              </div>
              <div data-id="element-310">
                <div className="mb-1 text-[10px] text-orange-400" data-id="element-311">
                  ⭐⭐⭐⭐⭐
                </div>
                <p className="text-xs font-medium text-gray-900 m-0" data-id="element-312">
                  {t.quote}
                </p>
                <p className="text-[10px] text-gray-500 mt-1 mb-0" data-id="element-313">
                  {t.author}
                </p>
              </div>
            </div>)}
        </div>

        {/* BARRA DE CONFIANZA */}
        <div className="mt-6 flex flex-wrap items-center justify-center gap-3 text-xs text-gray-500" data-id="element-314">
          <span data-id="element-315">🛡️ Garantía 7 días</span>
          <span data-id="element-316">⚡ Acceso inmediato</span>
          <span data-id="element-317">🔒 Pago 100% seguro</span>
          <span data-id="element-318">💳 Mercado Pago | Tarjeta</span>
          <span data-id="element-319">📄 PDF listo para imprimir</span>
        </div>

      </div>
    </section>;
}